module.exports = __webpack_public_path__ + "static/media/nr.3d67dbae.svg";